import {Component, EventEmitter, Input, Output, Self, Optional, ChangeDetectorRef, ViewChild, ElementRef} from '@angular/core';
import {ControlValueAccessor, NgControl} from '@angular/forms';

@Component({
  selector: 'bzg-date-picker',
  templateUrl: 'date-picker.component.html',
  styleUrls: ['date-picker.component.scss'],
})

export class BzgDatePickerComponent implements ControlValueAccessor {

    get value(): Date {
        return this._value;
    };

    set value(v: Date) {
        if (v !== this._value) {
            this._value = v;
            this.onChange(v);
            this.hasErrors();
        }
    }

    constructor(@Self() @Optional() public ngControl: NgControl, private changeDetector: ChangeDetectorRef) {
        if (this.ngControl) {
          this.ngControl.valueAccessor = this;
        }
    }
    @Input() id = Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 6);
    @Input() required = true;
    @Input() minDate: Date;
    @Input() maxDate: Date;
    @Output() public keypress = new EventEmitter();
    @Output() public blur = new EventEmitter();
    @Output() public focus = new EventEmitter();

    public hasLabel = true;

    private _value: Date = new Date();

    onTouched: () => void;

    @ViewChild('inputLabel', { static: false}) inputLabel: ElementRef;
    @ViewChild('dpDateControl', { static: false}) dpDateControl: any;
    onChange(value: Date) {}

    ngAfterViewInit(): void {
        // ng-content child nodes not including comments
        const labelChildNodes = Array.prototype.slice.call(this.inputLabel.nativeElement.childNodes).filter(node => node.nodeType !== 8);
        this.hasLabel = labelChildNodes.length;
        this.changeDetector.detectChanges();
    }

    writeValue(value: Date): void {
        this.value = value || null;
    }

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    onKeyPress($event) {
        this.onChange(this.value);
        this.keypress.emit($event);
    }

    onBlur($event) {
        this.onTouched();
        this.blur.emit($event);
    }

    onFocus($event) {
        this.focus.emit($event);
    }

    hasErrors(): void {
        if (this.ngControl && this.dpDateControl && this.dpDateControl.errors) {
            this.ngControl.control.setErrors(this.dpDateControl.errors);
        }
    }

    getConfiguration() {
        const bsConfig = {};
        if(this.minDate) {
            bsConfig['minDate'] = this.minDate;
        }

        if(this.maxDate) {
            bsConfig['maxDate'] = this.maxDate;
        }

        bsConfig['showWeekNumbers'] = false;
        bsConfig['adaptivePosition'] = true;

        return bsConfig;
    }
}
